import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import CTAButton from './CTAButton';
interface Slide {
  image: string;
  title: string;
  description: string;
  buttonText?: string;
  buttonLink?: string;
}
const ImageSlider: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides: Slide[] = [{
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4SpwaRdQ2fycsgRtD9iWy5/vfvfv.png',
    title: 'From Bump to Baby and Beyond!',
    description: 'Supporting African moms with trusted products, baby nutrition guides, and practical resources.',
    buttonText: 'Shop Now',
    buttonLink: '/shop'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/71LHJfrm1M3EgMaBNevw1r/vtgt.png',
    title: 'Empowering Every Stage of Motherhood',
    description: 'Helping pregnant women, nursing mothers, and expectant mothers maximize their life with expert guidance, community support, and essential resources.',
    buttonText: 'Join Our Community',
    buttonLink: '/community'
  }];
  const nextSlide = () => {
    setCurrentSlide(prev => prev === slides.length - 1 ? 0 : prev + 1);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => prev === 0 ? slides.length - 1 : prev - 1);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  return <div className="relative h-[500px] md:h-[600px] overflow-hidden" data-id="element-79">
      {slides.map((slide, index) => <div key={index} className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${currentSlide === index ? 'opacity-100 z-10' : 'opacity-0 z-0'}`} data-id="element-80">
          <div className="absolute inset-0 bg-black/30 z-10" data-id="element-81"></div>
          <img src={slide.image} alt={slide.title} className="w-full h-full object-cover" data-id="element-82" />
          <div className="absolute inset-0 flex items-center z-20" data-id="element-83">
            <div className="container mx-auto px-4" data-id="element-84">
              <div className="max-w-xl text-white" data-id="element-85">
                <h1 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-86">
                  {slide.title}
                </h1>
                <p className="text-lg md:text-xl mb-8" data-id="element-87">{slide.description}</p>
                {slide.buttonText && <CTAButton text={slide.buttonText} link={slide.buttonLink || '#'} data-id="element-88" />}
              </div>
            </div>
          </div>
        </div>)}
      {/* Navigation arrows */}
      <button onClick={prevSlide} className="absolute left-4 top-1/2 -translate-y-1/2 z-30 bg-white/30 hover:bg-white/50 rounded-full p-2 text-white" aria-label="Previous slide" data-id="element-89">
        <ChevronLeft size={24} data-id="element-90" />
      </button>
      <button onClick={nextSlide} className="absolute right-4 top-1/2 -translate-y-1/2 z-30 bg-white/30 hover:bg-white/50 rounded-full p-2 text-white" aria-label="Next slide" data-id="element-91">
        <ChevronRight size={24} data-id="element-92" />
      </button>
      {/* Dots navigation */}
      <div className="absolute bottom-6 left-0 right-0 z-30 flex justify-center gap-2" data-id="element-93">
        {slides.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-3 h-3 rounded-full ${currentSlide === index ? 'bg-white' : 'bg-white/50'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-94" />)}
      </div>
    </div>;
};
export default ImageSlider;